.button {
  min-height: 40px;
}
